import axios from "axios";
import store from "@/store";
import qs from 'qs'
import merge from 'lodash/merge'
// create an axios instance
const http = axios.create({
    baseURL: '/api/mongol', // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000, // request timeout
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
});

// request interceptor
http.interceptors.request.use(
    config => {
        if (config.url.indexOf("http") > -1) config.baseURL = "";

        // do something before request is sent
        if (store.getters.token) {
            config.headers['Authorization'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        if (process.env.NODE_ENV === "development") {
            console.log(error); // for debug
        }
        return Promise.reject(error);
    }
);

// response interceptor
http.interceptors.response.use(
    response => {

        const res = response;

        return res;
    },
    error => {
        if (process.env.NODE_ENV === "development") {
            console.log(error); // for debug
        }

        return Promise.reject(error);
    }
);
/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = actionName => {
    return '/api/mongol' + actionName;
};

/**
 * im请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornImUrl = actionName => {
    return '/api/mongol' + actionName;
};

/**
 * im ws 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornWsImUrl = actionName => {
    return '/api/mongol' + actionName;
};

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
    var defaults = {
        't': new Date().getTime()
    };
    return openDefultParams ? merge(defaults, params) : params;
};

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
    var defaults = {
        't': new Date().getTime()
    };
    data = openDefultdata ? merge(defaults, data) : data;
    return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

export default http;
